import analytics, { events } from '../../../shared/analytics';

import BasePage from '../../components/base-page/base-page';
import Switcher from '../../components/switcher/switcher';
import Carousel from '../../components/carousel/carousel';
import VideoModal from '../../components/video-modal/video-modal';

import './teams.scss';

class TeamsPage extends BasePage {
  ui = {
    promoAppsCarousel: '.js-promo-apps-carousel',
    screenshotsSwitcher: '.js-screenshots-switcher',
  };

  uiCollections = {
    bookDemoButtons: '.js-book-demo-button',
  };

  events = {
    'click @uiCollections.bookDemoButtons': 'handleBookDemoButtonClick',
  };

  onInit() {
    super.onInit();

    this.promoAppsCarousel = new Carousel({ rootElement: this.ui.promoAppsCarousel });
    this.promoAppsCarousel.init();
    this.screenshotsSwitcher = new Switcher({ rootElement: this.ui.screenshotsSwitcher });
    this.screenshotsSwitcher.init();
    this.videoModal = new VideoModal();
    this.videoModal.init();
  }

  handleBookDemoButtonClick() {
    analytics.trackEvent(events.BOOK_DEMO);
  }
}

export default TeamsPage;

TeamsPage.initOnDomLoaded();
